import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './spinner.scss';

const Spinner = ({ size, className }) => (
  <span
    className={classNames('ig-spinner', `ig-spinner--${size}`, className)}
    role="status"
    aria-label="Loading"
  />
);

Spinner.defaultProps = {
  size: 'sm',
  className: null,
};

Spinner.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string,
};

export default Spinner;
